import { useParams } from 'react-router';

import Tbm3DidPreconditions from '@/features/engineoil/preconditions/common/Tbm3DidPreconditions';
import { SOURCE_DEVICE, SOURCE_TYPE } from '@/features/engineoil/utils/constants';
import { useGetEngineOilQuery } from '@/services/api';
import Cm4SsSeriesPreconditions from './Cm4SsSeriesPreconditions';
import PreconditionsSkeletonScreen from './PreconditionsSkeletonScreen';
import TBM3SsSeriesPreconditions from './TBM3SsSeriesPreconditions';

const Preconditions = () => {
    const { assetId } = useParams<{ assetId: string }>();
    const { data: engineOil, isLoading, error } = useGetEngineOilQuery(assetId!);

    if (isLoading || error || !engineOil) {
        return <PreconditionsSkeletonScreen />;
    }

    switch (engineOil.source_device) {
        case SOURCE_DEVICE.CM4:
            switch (engineOil.source_type) {
                case SOURCE_TYPE.SENSOR_SIGNAL_SERIES:
                    return <Cm4SsSeriesPreconditions />;
                case SOURCE_TYPE.DID:
                    return null;
                default:
                    return null;
            }
        case SOURCE_DEVICE.TBM3:
            switch (engineOil.source_type) {
                case SOURCE_TYPE.SENSOR_SIGNAL_SERIES:
                    return <TBM3SsSeriesPreconditions />;
                case SOURCE_TYPE.DID:
                    return <Tbm3DidPreconditions engineOil={engineOil} />;
                default:
                    return null;
            }
        default:
            return null;
    }
};

export default Preconditions;
